import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { WheelState } from './types';

export const initialState: WheelState = {
  isModalOpened: false,
  winnerId: null,
  spinTime: null
};

export const useWheelStore = createHookStore(
  STORE_NAMES.FORTUNE_WHEEL,
  initialState
);
